import React from 'react';
import { CoreTooltip } from '../components/Tooltip';

export function withTooltip(componentName: string) {
  return (WrappedComponent: any) => {
    const ComponentWithTooltip = (props: any) => {
      if (props.tooltip) {
        const { content, placement } = props.tooltip;
        const computedProps = {
          ...(placement && { placement }),
        };

        return (
          <CoreTooltip hasArrow label={content} {...computedProps}>
            <WrappedComponent {...props} />
          </CoreTooltip>
        );
      }

      return <WrappedComponent {...props} />;
    };

    ComponentWithTooltip.displayName = `withTooltip(${componentName})`;

    return ComponentWithTooltip;
  };
}
